import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of accounts based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('account_products', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single account based on his ID
 *
 * @param id the of the account requested
 */
export function getFromId(id) {
  return baseGetFromId('account_products', id);
}

/**
 * Get a single account based on his ID
 *
 * @param id the of the account requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('account_products', id, 'identification');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single account based on his ID
 *
 * @param id the of the account requested
 * @param data the new data of the account
 */
export function editFromId(id, data) {
  return baseEditFromId('account_products', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new account
 *
 * @param data the new data of the account
 */
export function newItem(data) {
  return baseNewItem('account_products', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all accounts to serve in a dropdown form choice
 */
export function fetchAccountProducts() {
  return baseIndex('account_products', 1, 0);
}
